
export const fontFaces = `
  // 500-600
@font-face {
  font-family: "segoe_uisemibold";
  src: url("../styles/css/segoe-ui-semibold-webfont.woff2") format("woff2"),
    url("../styles/css/segoe-ui-semibold-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

//400
@font-face {
  font-family: "Segoe UI Regular";
  font-style: normal;
  font-weight: normal;
  src: local("Segoe UI Regular"), url("../styles/css/Segoe UI.woff") format("woff");
}

//700
@font-face {
  font-family: "Segoe UI Bold";
  font-style: normal;
  font-weight: normal;
  src: local("Segoe UI Bold"), url("../styles/css/Segoe UI Bold.woff") format("woff");
}

`;
